import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Loading } from 'components/ui'

export function WeChatPopup() {
  const [params] = useSearchParams()
  const HOST_URL = process.env.REACT_APP_HOST
  const code = params.get('code') || ''

  useEffect(() => {
    window.opener.postMessage(code, HOST_URL)
    window.close()
  }, [])

  return <Loading fullScreen />
}
